/**
 * Mounts the singleton `ConnectionDiagnosticsDialog` once at app boot AND
 * registers its open-handler with `showConnectionDiagnostics` so every
 * existing UI consumer (Object Explorer tile, Table Explorer dropdown,
 * future tab-failure banner) routes to this dialog.
 *
 * The `connection-diagnostics:show_requested` CustomEvent and Umami event are
 * NOT fired here — `showConnectionDiagnostics` fires both before delegating, so
 * they land exactly once regardless of whether a handler is registered (#108).
 */

import { useEffect } from 'react';
import { ConnectionDiagnosticsDialog } from './ConnectionDiagnosticsDialog';
import { useDiagnosticsDialogStore } from './diagnosticsDialogStore';
import {
  registerConnectionDiagnosticsHandler,
  type ShowConnectionDiagnosticsArgs,
} from '../showConnectionDiagnostics';

export function ConnectionDiagnosticsDialogHost() {
  const openDialog = useDiagnosticsDialogStore((s) => s.openDialog);

  useEffect(() => {
    registerConnectionDiagnosticsHandler((args: ShowConnectionDiagnosticsArgs) => {
      openDialog(args);
    });
  }, [openDialog]);

  return <ConnectionDiagnosticsDialog />;
}
